import { render, staticRenderFns } from "./settingLive.vue?vue&type=template&id=be74283e&scoped=true&"
import script from "./settingLive.vue?vue&type=script&lang=js&"
export * from "./settingLive.vue?vue&type=script&lang=js&"
import style0 from "./settingLive.vue?vue&type=style&index=0&id=be74283e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be74283e",
  null
  
)

export default component.exports